import { initErrorReporting } from '@tcc/scarecrow';
import { initDataDog } from '../../utils/datadogUtils';

/**
 * Initialize scarecrow error reporting
 * @return {Promise}
 */
export default function setup() {

  initDataDog();
  initErrorReporting({});

  return Promise.resolve(true);
}
